"use strict";

define('libs/format/list',['./empty'], function (emptyFormatter) {
  var listFormatter = function listFormatter(emptyText) {
    var empty = emptyFormatter(emptyText);
    return function (value) {
      if (!value) {
        return empty(value);
      }
      return value.split(';').join(', ');
    };
  };
  return listFormatter;
});

